/**
 * Deterministic avatar helpers — same userId always produces the same colour
 * and same initials, so users keep a consistent visual identity across reloads.
 */

const PALETTE = [
  ['#FEE2E2', '#B91C1C'], // rose
  ['#FFEDD5', '#C2410C'], // orange
  ['#FEF3C7', '#92400E'], // amber
  ['#DCFCE7', '#15803D'], // green
  ['#CFFAFE', '#0E7490'], // cyan
  ['#DBEAFE', '#1D4ED8'], // blue
  ['#E0E7FF', '#4338CA'], // indigo
  ['#EDE9FE', '#6D28D9'], // violet
  ['#FAE8FF', '#A21CAF'], // fuchsia
  ['#FCE7F3', '#BE185D'], // pink
];

/** djb2-ish hash so it's stable and dependency-free. */
function hash(str: string): number {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function colorsForUser(userId: string): { bg: string; fg: string } {
  const [bg, fg] = PALETTE[hash(userId) % PALETTE.length];
  return { bg, fg };
}

export function initialsFor(name: string): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
